export const isExclusiveExperience = (exclusivity) => {
  return Boolean(exclusivity) && exclusivity !== 'ALL';
};

export const hasMatchingCardForExperience = (cards = [], exclusivity) => {
  if (!isExclusiveExperience(exclusivity)) {
    return true;
  }

  return Array.isArray(cards) && cards.includes(exclusivity);
};

export const getExclusiveConflicts = (items = [], cards = []) => {
  return items.filter((item) => !hasMatchingCardForExperience(cards, item.exclusivity));
};

export const hasExclusiveConflict = (items = [], cards = []) => {
  return getExclusiveConflicts(items, cards).length > 0;
};
